
  $(document).ready(function() {
	// Function to format the date as "Mmm DD, YYYY"
	function getFormattedToday() {
	  var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	  var today = new Date();
	  var month = months[today.getMonth()];
	  var day = today.getDate();
	  var year = today.getFullYear();
	  return month + " " + day + ", " + year;
	}
	// Select the element and update only the date part after "As of"
	$('#iqxz8o').each(function() {
	  var html = $(this).html();
	  // Use regex to find "As of ..." and replace date part
	  var updatedHtml = html.replace(/As of [A-Za-z]{3,9} \d{1,2}, \d{4}/, "As of " + getFormattedToday());
	  $(this).html(updatedHtml);
	}
					 );
  }
				   );
